import React from "react";
import "react-vis/dist/style.css";
import { Breadcrumb, Row, Col, Tabs, Collapse, message } from "antd";
import { CaretRightOutlined } from "@ant-design/icons";

import WeightDispute from "./WeightDispute";
import TransactionList from "./TransactionList.js";
import TopupList from "./TopupList.js";
import DragUpload from "../Form/DragUpload";

const routes = [
  { path: "", breadcrumbName: "App" },
  { path: "/transaction", breadcrumbName: "Transaction" },
];

const Transaction = () => {
  const searchUploadSuccessHandler = (res) => {
    message.info(`Please check your email after 5-20 minute`);
  };

  return (
    <div>
      <div className="header">
        <Row>
          <Col span={12}>
            <h2 className="detail-header-text">Transaction Details</h2>
          </Col>
          <Col span={12}>
            <Breadcrumb
              style={{ margin: "10px 0", textAlign: "right" }}
              routes={routes}
            />
          </Col>
        </Row>
      </div>

      <Collapse
        expandIcon={({ isActive }) => (
          <CaretRightOutlined rotate={isActive ? 90 : 0} />
        )}
      >
        <Collapse.Panel header="Bulk Search Transaction" key="bulkSearch">
          <DragUpload
            action={`${process.env.REACT_APP_SERVER_URL}/api/transaction/bulk/search/csv`}
            accept=".xls, .xlsx"
            method="post"
            onUploadSuccess={(res) => searchUploadSuccessHandler(res)}
            additionalDesc={`Excel file with "Search Tracking Number" columns.`}
          />
          <br />
        </Collapse.Panel>
      </Collapse>

      <div className="table mt-4">
        <Tabs defaultActiveKey="1" animated={true}>
          <Tabs.TabPane tab="All" key="All">
            <TransactionList />
          </Tabs.TabPane>

          <Tabs.TabPane tab="Consignment Purchase" key="consignmentPurchase">
            <TransactionList types="consignment_purchase" />
          </Tabs.TabPane>

          <Tabs.TabPane tab="Weight Dispute" key="weightDispute">
            <WeightDispute showButtons={{ refundWeightDispute: true }} />
          </Tabs.TabPane>

          <Tabs.TabPane tab="Weight Dispute Refund" key="weightDisputeRefund">
            <TransactionList types="refund-weight-dispute" />
          </Tabs.TabPane>

          <Tabs.TabPane tab="Top Up" key="TransactionList">
            <TopupList />
          </Tabs.TabPane>

          <Tabs.TabPane tab="Admin Manual" key="adminManual">
            <TransactionList types="Admin Manual" />
          </Tabs.TabPane>

          <Tabs.TabPane tab="Refund" key="Refund">
            <TransactionList
              types={["Refund System Error", "Refund Cancellation Order"]}
            />
          </Tabs.TabPane>

          <Tabs.TabPane tab="Cod Amendment" key="codAmendment">
            <TransactionList
              types={[
                "Refund Cod Amendment",
                "Refund NDR Amendment",
                "Charge Cod Amendment",
                "Charge NDR Amendment",
              ]}
            />
          </Tabs.TabPane>

          <Tabs.TabPane tab="COD Refund" key="codRefund">
            <TransactionList types="refund-cod-charge" />
          </Tabs.TabPane>

          <Tabs.TabPane tab="NDR Refund" key="ndrRefund">
            <TransactionList types="refund-next-day-remittance-charge" />
          </Tabs.TabPane>

          <Tabs.TabPane tab="Return Fee Refund" key="returnFeeRefund">
            <TransactionList types="Refund Return Fee" />
          </Tabs.TabPane>

          <Tabs.TabPane tab="Discount" key="discount">
            <TransactionList types="Discount" />
          </Tabs.TabPane>

          <Tabs.TabPane tab="Referral Program" key="refereeProgram">
            <TransactionList
              types={["Referral Bonus", "Referee Bonus", "Top up Commission"]}
            />
          </Tabs.TabPane>
        </Tabs>
      </div>
    </div>
  );
};

export default Transaction;
